
// --- Constants (shared with UI hook and BlockWrap where needed) ---

export const BLOCK_HASH_PREFIX = "block-"

/** Class added to the block element while it is being scrolled to and highlighted */
export const BLOCK_LINK_HIGHLIGHT_CLASS = "smooth-scroll-active"

/** ID of the temporary <style> element injected for block-link highlight animation */
export const BLOCK_LINK_HIGHLIGHT_STYLE_ID = "smooth-scroll-temp-style"

/** Duration of highlight animation from useScrollToAndHighlight temporary styles. */
export const BLOCK_LINK_HIGHLIGHT_DURATION_MS = 2500
